import React from 'react'
import logo from '../../assets/logo.png';
import logowhite from '../../assets/logowhite.png';
import { Link } from 'react-router-dom';
import { useTheme } from '../../context/ThemeProvider';
import useAuth from '../../hooks/useAuth';
import { hasActiveSubscription } from '../../utils/subscriptionUtils';

const Footer = () => {
    const { darkMode } = useTheme();
    const { auth } = useAuth();
    const isSubscribed = hasActiveSubscription(auth?.subscription);

    return (
        <footer className={darkMode ? 'mt-20 bg-[#080E0B] text-[var(--grey)]' : 'mt-20 bg-white'} role="contentinfo">
            <div className='grid w-full grid-cols-1 gap-10 px-3 py-14 md:grid-cols-4 md:px-4 lg:px-5'>
                <div>
                    <Link to="/" className='block h-6 w-fit' aria-label="Shotkut home">
                        <img
                            src={darkMode ? logowhite : logo}
                            alt="Shotkut logo"
                            width="121"
                            height="24"
                            className='h-full w-auto object-contain'
                        />
                    </Link>
                    <p className="mt-4 max-w-[280px] text-sm">
                        India's leading stock video platform. 10,000+ premium HD & 4K Indian footage clips for creative professionals.
                    </p>
                </div>

                <nav className='flex flex-col' aria-label="Quick links">
                    <div className='mb-6 font-semibold'>Explore</div>
                    <Link to='/' className='hover:text-[var(--primary)]'>Browse Videos</Link>
                    <Link to='/search' className='hover:text-[var(--primary)]'>Search Footage</Link>
                    <Link to='/collections' className='hover:text-[var(--primary)]'>Collections</Link>
                    {!isSubscribed && (
                        <Link to='/pricing' className='hover:text-[var(--primary)]'>Pricing & Plans</Link>
                    )}
                </nav>

                <nav className='flex flex-col' aria-label="Company links">
                    <div className='mb-6 font-semibold'>Company</div>
                    <Link to='/about' className='hover:text-[var(--primary)]'>About Us</Link>
                    <Link to='/faqs' className='hover:text-[var(--primary)]'>FAQs</Link>
                    <Link to='/contactus' className='hover:text-[var(--primary)]'>Contact Us</Link>
                </nav>

                <nav className='mr-auto flex flex-col' aria-label="Legal links">
                    <div className='mb-6 font-semibold'>Legal</div>
                    <Link to='/privacypolicy' className='hover:text-[var(--primary)]'>Privacy Policy</Link>
                    <Link to='/termsandconditions' className='hover:text-[var(--primary)]'>Terms and Conditions</Link>
                    <Link to='/refundpolicy' className='hover:text-[var(--primary)]'>Cancellation and Refund</Link>
                    <Link to='/shipmentanddelivery' className='hover:text-[var(--primary)]'>Shipment and Delivery</Link>
                </nav>
            </div>

            <div className={`border-t py-4 text-center ${darkMode ? 'border-gray-800' : 'border-gray-200'}`}>
                <p className="text-sm">
                    &copy; {new Date().getFullYear()} Shotkut by Gath Productions. All rights reserved.
                </p>
            </div>
        </footer>
    )
}

export default Footer
